import React from "react";
import tw, { css } from "twin.macro";
import { motion } from "framer-motion";

function AboutSection() {
  return (
    <div tw="bg-primary">
      <div tw="container mx-auto">
        <div
          css={[
            tw`flex justify-center items-center`,
            css`
              height: calc(100vh - 80px);
            `,
          ]}
        >
          <motion.p
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: [1, 2, 1] }}
            transition={{
              ease: "easeIn",
              duation: 0.5,
            }}
            tw="text-secondary text-7xl text-center font-black"
          >
            Coming Soon
          </motion.p>
        </div>
      </div>
    </div>
  );
}

export default AboutSection;
